export const SET_TOKEN = 'SET_TOKEN'
export const SET_ERROR = 'SET_ERROR'
export const SET_USER = 'SET_USER'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const SET_USER_PROFILE_FIELD = 'SET_USER_PROFILE_FIELD'
export const SET_USER_PROFILE_ADDRESS_FIELD = 'SET_USER_PROFILE_ADDRESS_FIELD'
export const SET_USER_VALIDATION_ERRORS = 'SET_USER_VALIDATION_ERRORS'
export const CLEAR_USER_VALIDATION_ERROR_BY_PROPERTY_PATH = 'CLEAR_USER_VALIDATION_ERROR_BY_PROPERTY_PATH'

export default {
  SET_TOKEN,
  SET_ERROR,
  SET_USER,
  SET_USER_PROFILE,
  SET_USER_PROFILE_FIELD,
  SET_USER_PROFILE_ADDRESS_FIELD,
  SET_USER_VALIDATION_ERRORS,
  CLEAR_USER_VALIDATION_ERROR_BY_PROPERTY_PATH
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js